import React from "react";
import { AnimatedNumber } from "../admin/admin_dashboard/DashCards";

const ROLES = [
  { 
    key: "Ic", 
    label: "IC", 
    dotColor: "bg-indigo-600"
  },
  { 
    key: "Bsp", 
    label: "BSP", 
    dotColor: "bg-blue-600"
  },
  { 
    key: "Dsp", 
    label: "DSP", 
    dotColor: "bg-amber-600"
  },
  { 
    key: "Bd", 
    label: "BD", 
    dotColor: "bg-teal-600"
  },
  { 
    key: "SalesEnabler", 
    label: "Sales Enabler", 
    dotColor: "bg-violet-600"
  },
  { 
    key: "Dealer", 
    label: "Dealer", 
    dotColor: "bg-slate-700"
  },
  { 
    key: "Studio", 
    label: "Studio", 
    dotColor: "bg-rose-600"
  },
];

const RoleIndicator = ({ data = {}, roles = [], onRoleClick }) => {
  // If roles array has items, filter the visibility list; otherwise show all cards.
  const visibleRoles = React.useMemo(() => {
    if (!roles || roles.length === 0) return ROLES;
    
    // Normalize user-selected roles to lowercase for accurate matching
    const selectedRolesLower = roles.map(r => String(r).toLowerCase().replace(/\s+/g, ''));
    
    return ROLES.filter((role) => {
      const keyMatch = role.key.toLowerCase();
      const labelMatch = role.label.toLowerCase().replace(/\s+/g, '');
      
      return selectedRolesLower.includes(keyMatch) || selectedRolesLower.includes(labelMatch);
    });
  }, [roles]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3 w-full">
      {visibleRoles.map((role) => {
        const total = data[`total${role.key}`] || 0;
        const created = data[`created${role.key}`] !== undefined ? data[`created${role.key}`] : total;
        const active = data[`total${role.key}`] || 0;
        const quotationsCreated = data[`quotations${role.key}`] || 0;
        const activeLogins = data[`active${role.key}`] || 0;

        return (
          <div 
            key={role.key} 
            className="relative hover:z-50 bg-white rounded-lg px-3 py-2.5 border border-slate-200 shadow-[0_2px_4px_0_rgba(0,0,0,0.02)] flex flex-col justify-between cursor-pointer hover:shadow-md transition-shadow duration-200"
            onClick={() => onRoleClick && onRoleClick(role.label)}
          >
            <div className={`absolute top-0 left-0 right-0 h-[3px] rounded-t-lg ${role.dotColor}`} />
            <div className="flex items-center gap-1.5 mb-2 pb-1.5 mt-1 border-b border-slate-50">
              <div className={`w-1.5 h-1.5 rounded-full shrink-0 ${role.dotColor}`} />
              <span className="text-[11px] font-bold text-slate-700 uppercase tracking-wide truncate">
                {role.label}
              </span>
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between group relative cursor-default">
                <span className="text-[10px] text-slate-500 font-medium">Quoted Users</span>
                <span className="text-sm font-bold text-slate-900 font-mono"><AnimatedNumber value={active} /></span>
                <div className="absolute bottom-full right-0 mb-1 hidden group-hover:block bg-gray-800 text-white text-[10px] rounded py-1 px-2 whitespace-nowrap z-[100] shadow-lg pointer-events-none">
                  Users active and created a quotation in this period
                  <div className="absolute top-full right-2 border-4 border-transparent border-t-gray-800"></div>
                </div>
              </div>

              <div className="flex items-center justify-between group relative cursor-default">
                <span className="text-[10px] text-slate-500 font-medium">Quotations Created</span>
                <span className="text-sm font-bold text-slate-900 font-mono"><AnimatedNumber value={quotationsCreated} /></span>
                <div className="absolute bottom-full right-0 mb-1 hidden group-hover:block bg-gray-800 text-white text-[10px] rounded py-1 px-2 whitespace-nowrap z-[100] shadow-lg pointer-events-none">
                  Total number of quotations created by this role
                  <div className="absolute top-full right-2 border-4 border-transparent border-t-gray-800"></div>
                </div>
              </div>

              <div className="flex items-center justify-between group relative cursor-default">
                <span className="text-[10px] text-slate-500 font-medium">Active {role.label}s</span>
                <span className="text-sm font-bold text-slate-900 font-mono"><AnimatedNumber value={activeLogins} /></span>
                <div className="absolute bottom-full right-0 mb-1 hidden group-hover:block bg-gray-800 text-white text-[10px] rounded py-1 px-2 whitespace-nowrap z-[100] shadow-lg pointer-events-none">
                  Unique users who logged in during this period
                  <div className="absolute top-full right-2 border-4 border-transparent border-t-gray-800"></div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RoleIndicator;